import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getCountry, getCurrencyFromCountry} from '../utils/regionUtils'

interface CurrencyState {
    currency: string
    country: string
    isLoading: boolean
    isInitialized: boolean
}

const initialState: CurrencyState = {
    currency: 'EUR',
    country: '',
    isLoading: false,
    isInitialized: false
}

export const detectCurrency = createAsyncThunk(
    'currency/detectCurrency',
    async () => {
        const country = await getCountry()
        return {
            currency: getCurrencyFromCountry(country),
            country: country === 'XX' ? '' : country
        }
    }
)

export const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(detectCurrency.pending, (state) => {
                state.isLoading = true
            })
            .addCase(detectCurrency.fulfilled, (state, action) => {
                state.currency = action.payload.currency
                state.country = action.payload.country
                state.isLoading = false
                state.isInitialized = true
            })
            .addCase(detectCurrency.rejected, (state) => {
                state.currency = 'EUR' //Should default to whatever the Stripe default currency is for prices
                state.country = ''
                state.isLoading = false
                state.isInitialized = true
            })
    }
})

export const selectCurrency = (state: { currency: CurrencyState }) =>
    state.currency.currency

export const selectCountry = (state: { currency: CurrencyState }) =>
    state.currency.country

export const selectCurrencyLoading = (state: { currency: CurrencyState }) =>
    state.currency.isLoading

export const selectCurrencyInitialized = (state: { currency: CurrencyState }) =>
    state.currency.isInitialized

export default currencySlice.reducer
